import { render, staticRenderFns } from "./TableAppointment.vue?vue&type=template&id=55fff694"
import script from "./TableAppointment.vue?vue&type=script&lang=js"
export * from "./TableAppointment.vue?vue&type=script&lang=js"
import style0 from "./TableAppointment.vue?vue&type=style&index=0&id=55fff694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports